module.exports = __webpack_public_path__ + "img/cp-14.d0df92a0.jpg";